import React from 'react';

function ZoomModal({ zoomImageUrl, onClose }) {
  if (!zoomImageUrl) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <img
        src={zoomImageUrl}
        alt="Zoomed"
        style={{ maxWidth: '90%', maxHeight: '90%' }}
      />
    </div>
  );
}

export default ZoomModal;
